import React, { createContext, useContext } from 'react';
import httpService from 'services/http';
import { useFeatureFlag } from 'context/featureFlagContext';

const HttpContext = createContext({
	httpServiceInstance: null,
});

const useHttp = () => useContext(HttpContext);

function HttpProvider({ children }) {
	const { subscriptionTokenEnabled } = useFeatureFlag();

	const httpServiceInstance = new httpService({ subscriptionTokenEnabled });

	return <HttpContext.Provider value={{ httpServiceInstance }}>{children}</HttpContext.Provider>;
}

export { useHttp, HttpProvider };
